function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2457 19.125H31.9249V25.5L29.7966 24.0855L27.6682 25.5V19.125H22.3474C21.7621 19.125 21.2833 19.6031 21.2833 20.1875V32.9375C21.2833 33.5219 21.7621 34 22.3474 34H37.2457C37.831 34 38.3099 33.5219 38.3099 32.9375V20.1875C38.3099 19.6031 37.831 19.125 37.2457 19.125ZM11.7058 14.875H26.6041C27.1894 14.875 27.6682 14.3969 27.6682 13.8125V1.0625C27.6682 0.478125 27.1894 0 26.6041 0H21.2833V6.375L19.1549 4.96055L17.0266 6.375V0H11.7058C11.1205 0 10.6416 0.478125 10.6416 1.0625V13.8125C10.6416 14.3969 11.1205 14.875 11.7058 14.875ZM15.9624 19.125H10.6416V25.5L8.5133 24.0855L6.38498 25.5V19.125H1.06416C0.478873 19.125 0 19.6031 0 20.1875V32.9375C0 33.5219 0.478873 34 1.06416 34H15.9624C16.5477 34 17.0266 33.5219 17.0266 32.9375V20.1875C17.0266 19.6031 16.5477 19.125 15.9624 19.125Z",
  fill: "white"
});

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    viewBox: "0 0 39 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.ee1d65c0db62c8524972f59302a2d6f8.svg";
export { ForwardRef as ReactComponent };